<!--
무자료 수동등록 > 등록
------------------------------------
-->
<template>
    <div>
        <h3>
            <i class="material-icons md-36">edit</i>
            <span class="uk-text-middle">무자료 수정</span>
        </h3>
        <div class="input-form">
            <div class="uk-text-right">
            </div>
            <table class="input-table">
                <tr>
                    <th class="highlight">
                        <i class="material-icons">
                            local_shipping
                        </i>
                        트래킹번호
                    </th>
                    <td>
                        <app-input-text
                            class=""
                            ref="trackingNo"
                            v-model="inputs.tracking_no"
                            id="tracking_no"
                        ></app-input-text>
                    </td>

                </tr>


                <tr>
                    <th class="highlight">
                        <i class="material-icons">
                            account_circle
                        </i>
                        회원사
                    </th>
                    <td>
                        {{ prod.user_mailbox }}
                        <div class="uk-text-muted uk-text-small">* 회원사는 수정할 수 없습니다. 삭제 후 다시 등록하세요</div>
                    </td>
                </tr>

                <tr>
                    <th class="highlight">
                        <i class="material-icons">
                            camera
                        </i>
                        사진촬영
                    </th>
                    <td>
                        <app-file-uploader
                            ref="upload"
                            class="uk-margin-right"
                            :csrf-token="csrfToken"
                            :type="2"
                            :prod-id="prod.id"
                            :session-owner="sessionOwner"
                            header-text=""
                            header-button-is-primary
                            vertical-layout
                            @update:ids="val => fileIds = val"
                        >
                            <template slot="headerBar" slot-scope="{displayAddWebcamButton, openWebcamArea, displayAddPhoneButton, displayAddLocalButton, displayAddUrlButton}">
                                <h5
                                    class="uk-margin-small uk-text-left"
                                >
                                    <i class="material-icons uk-text-middle md-36">
                                        attachment
                                    </i>
                                    <span class="uk-text-middle uk-text-primary">최대한 가까이 찍어서 운송장사진, 내용사진, (인보이스 사진) 올려주세요</span>
                                </h5>

                                <div class="uk-flex uk-flex-between">
                                    <div class="uk-flex uk-flex-left uk-flex-top uk-flex-wrap">
                                        <!-- 웹캠 촬영 버튼 -->
                                        <button
                                            type="button"
                                            class="uk-button uk-button-black uk-margin-small-right uk-margin-small-bottom"
                                            v-show="displayAddWebcamButton"
                                            @click="uploadStartWebcam"
                                            title="웹캠 이미지 촬영"
                                        >
                                            <i class="material-icons">camera</i>
                                            WEBCAM
                                        </button>

                                        <!-- 웹캠 촬영 종료 버튼 -->
                                        <button
                                            type="button"
                                            class="uk-button uk-button-danger uk-margin-small-right uk-margin-small-bottom"
                                            v-show="openWebcamArea"
                                            @click="uploadEndWebcam"
                                            title="웹캠 촬영 종료"
                                        >
                                            <i class="material-icons">close</i>
                                            CLOSE WEBCAM
                                        </button>

                                        <!-- 스마트폰 촬영 버튼 -->
                                        <button
                                            type="button"
                                            class="uk-button uk-button-black uk-margin-small-right uk-margin-small-bottom"
                                            v-show="displayAddPhoneButton"
                                            @click="uploadStartPhotoSession"
                                            title="스마트폰으로 이미지 촬영"
                                        >
                                            <i class="material-icons">smartphone</i>
                                            PHONE
                                        </button>

                                        <!-- 파일추가 버튼 -->
                                        <button
                                            type="button"
                                            class="uk-button uk-button-black uk-margin-small-right uk-margin-small-bottom"
                                            v-show="displayAddLocalButton"
                                            @click="uploadAddLocal"
                                            title="PC에서 업로드"
                                        >
                                            <span uk-icon="icon: plus-circle"></span>
                                            ADD FILE
                                        </button>

                                        <!-- URL추가 버튼 -->
                                        <button
                                            type="button"
                                            class="uk-button uk-button-black uk-margin-small-right uk-margin-small-bottom"
                                            v-show="displayAddUrlButton"
                                            @click="uploadAddUrl"
                                            title="ADD IMAGE BY URL"
                                        >
                                            <span uk-icon="icon: plus-circle"></span>
                                            ADD URL
                                        </button>
                                    </div>


                                    <div>
                                        <!-- 세팅버튼 -->
                                        <a class="uk-link-reset" @click="uploadOpenSettingModal">
                                            <i class="material-icons md-36">settings</i>
                                        </a>
                                    </div>

                                </div>
                            </template>
                        </app-file-uploader>
                    </td>
                </tr>

                <tr>
                    <th class="highlight">
                        <i class="material-icons">
                            info
                        </i>
                        수량(QTY)
                    </th>
                    <td>
                        <app-input-text
                            class=""
                            v-model="inputs.amount"

                            placeholder="낱개 또는 세트 수량을 적어주세요"
                        ></app-input-text>
                    </td>

                </tr>

                <tr>
                    <th class="">
                        <i class="material-icons">
                            account_circle
                        </i>
                        수취인이름
                    </th>
                    <td>
                        <app-input-text
                            class=""
                            v-model="inputs.tracking_recipient_name"
                        ></app-input-text>
                    </td>
                </tr>

                <tr>
                    <th class="">
                        <i class="material-icons">
                            info
                        </i>
                        상품명
                    </th>
                    <td>
                        <div class="uk-margin-small uk-text-left">
                            <i class="material-icons uk-text-middle md-36">
                                edit
                            </i>
                            <span class="uk-text-middle uk-text-primary">상품박스 파손, 내품 파손 오염, 신발 정품 박스 아닌경우 메모적어주세요</span>
                        </div>

                        <app-input-text
                            class=""
                            v-model="inputs.name"

                            placeholder=""
                        ></app-input-text>
                    </td>
                </tr>


                <tr>
                    <th class="">
                        <i class="material-icons">
                            info
                        </i>
                        사이즈
                    </th>
                    <td>
                        <app-input-text
                            class=""
                            v-model="inputs.size"
                        ></app-input-text>
                    </td>

                </tr>
                <tr>
                    <th>
                        <i class="material-icons">
                            info
                        </i>
                        색상
                    </th>
                    <td>
                        <app-input-text
                            class=""
                            v-model="inputs.color"
                        ></app-input-text>
                    </td>
                </tr>
                <tr>
                    <th>
                        <i class="material-icons">
                            info
                        </i>
                        색상
                    </th>
                    <td>
                        <app-input-text
                            class=""
                            v-model="inputs.color"
                        ></app-input-text>
                    </td>
                </tr>
                <tr>
                    <th>
                        <i class="material-icons">
                            info
                        </i>
                        유통기한
                    </th>
                    <td>
                        <div class="uk-margin-small uk-text-left">
                            <i class="material-icons uk-text-middle md-36">
                                edit
                            </i>
                            <span class="uk-text-middle uk-text-primary bg-yellow">건강식품/식품, 동물영양제인 경우 꼭 입력해 주세요</span>
                        </div>
                        <app-input-text
                            class=""
                            v-model="inputs.expiration_date"
                            paceholder="날짜입력"
                        ></app-input-text>
                    </td>
                </tr>

                <tr>
                    <th>
                        <i class="material-icons">
                            location_on
                        </i>
                        보관장소
                    </th>
                    <td>
                        <app-input-text
                            class=""
                            v-model="inputs.storage"
                        ></app-input-text>

                        <div class="uk-text-left uk-margin-small-top">
                            <button
                                type="button"
                                class="uk-button uk-button-black uk-button-large"
                                @click="printLabel(arguments, prod.id)"
                                title="현재 상품의 보관라벨을 출력합니다"
                            >
                                <i class="material-icons">print</i>
                                <span class="text">PRINT LABEL</span>
                            </button>
                        </div>
                    </td>
                </tr>

            </table>

            <div class="uk-margin-top uk-text-center">


                <button
                    type="button"
                    class="uk-button uk-button-large uk-button-white uk-margin-right"
                    @click="$emit('click:cancel-update')"
                >
                    <i class="material-icons">close</i> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-large uk-button-primary"
                    @click="submit"
                >
                    <i class="material-icons">check_circle</i> 저장
                </button>
            </div>
        </div>


        <!-- 완료창 -->
        <div ref="modal" class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
            <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-1-3">

                <div class="uk-modal-body">
                    <div class="uk-text-large3 uk-text-black uk-text-center">
                        수정되었습니다.
                    </div>
                </div>

                <div class="uk-modal-footer uk-text-center">
                    <button
                        ref="buttonOk"
                        type="button"
                        class="uk-button uk-button-large uk-button-white"
                        @click="closeSuccessAlert"
                    >
                        <i class="material-icons">check</i> 확인
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    export default {
        components: {
        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },


            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 사용자명
             */
            loginUserName: {
                type: String,
                default: null,
            },

            // (array) 지역 회원사 옵션
            regionMemberOptions: {
                type: Array,
                default: [],
            },

            // (int) 업로드모듈에서 사용할 로그인ID
            sessionOwner: {
                type: Number,
                default: null,
            },



        },
        data: function () {
            return {
                // (object) 입력값
                inputs: {},

                // (object) 상품정보
                prod: {},

                // (bool) ajax 처리중여부 (중복실행방지)
                isAjaxing: false,

                // (Array) 업로드 파일ID 배열
                fileIds: [],
            };
        },
        mounted: function () {
        },
        computed: {

        },
        methods: {


            // 업로드모듈 > startWebcam
            uploadStartWebcam() {
                this.$refs.upload.startWebcam();
            },

            // 업로드모듈 > endWebcam
            uploadEndWebcam() {
                this.$refs.upload.endWebcam();
            },

            // 업로드모듈 > startPhotoSession
            uploadStartPhotoSession() {
                this.$refs.upload.startPhotoSession();
            },

            // 업로드모듈 > addUrl
            uploadAddLocal() {
                this.$refs.upload.startAddLocal();
            },

            // 업로드모듈 > addUrl
            uploadAddUrl() {
                this.$refs.upload.startAddUrl();
            },

            // 업로드모듈 > 세팅창 실행
            uploadOpenSettingModal() {
                this.$refs.upload.openSettingModal();
            },

            /**
             * 수정 폼을 보여줌
             */
            show(prod) {
                this.inputs = {
                    amount: prod.amount,
                    size: prod.size,
                    color: prod.color,
                    name: prod.name,
                    //buy_order_code: prod.buy_order_code,
                    //memo: prod.memo,
                    tracking_no: prod.tracking_no,
                    tracking_recipient_name: prod.tracking_recipient_name,
                    //user_id: prod.user_id,

                    expiration_date: prod.expiration_date,
                    storage: prod.storage,
                };

                this.prod = prod;

                // 업로드모듈 초기화 (Promise 실행)
                this.fileIds = [];
                this.$refs.upload.initPromise(new Promise((resolve, reject) => {
                    let timer = setInterval(() => {
                        // prodId 가 업로드 컴포넌트에 파라메터로 전달되었음을 확인한 후 init
                        if (this.$refs.upload.getProdId() === this.prod.id) {
                            resolve();
                            clearInterval(timer);
                        }
                    }, 500);

                }));

            },

            /**
             * 완료창 실행
             */
            openSuccessAlert() {
                UIkit.util.once(this.$refs.modal, 'shown', () => {
                    this.$refs.buttonOk.focus();
                });
                UIkit.modal(this.$refs.modal).show();
            },

            /**
             * 완료창 종료
             */
            closeSuccessAlert() {
                UIkit.util.once(this.$refs.modal, 'hidden', () => {
                    this.$emit('updated', this.prod);
                });
                UIkit.modal(this.$refs.modal).hide();
            },

            /**
             * 라벨프린트
             */
            printLabel(args, prod_id) {
                $.app.print.store_label(args, prod_id);
            },

            /**
             * submit
             */
            submit() {
                // 실행중이면 skip
                if (this.isAjaxing) {
                    return;
                }
                this.isAjaxing = true;

                // 트래킹검증
                if (! this.inputs.tracking_no) {
                    alert('트래킹번호를 반드시 입력하세요');
                    this.isAjaxing = false;
                    return;
                }

                // 수량검증
                if (! this.inputs.amount) {
                    alert('수량을 반드시 입력하세요');
                    this.isAjaxing = false;
                    return;
                }

                // promise 생성
                let p = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/regions/' + this.regionId + '/nodata-stocks/' + this.prod.id,
                        data: {
                            '_token': this.csrfToken,
                            'file_ids': JSON.stringify(this.fileIds),

                            tracking_no: this.inputs.tracking_no,
                            tracking_recipient_name: this.inputs.tracking_recipient_name,

                            amount: this.inputs.amount,
                            size: this.inputs.size,
                            color: this.inputs.color,
                            name:  this.inputs.name,
                            //buy_order_code: this.inputs.buy_order_code,
                            //memo: this.inputs.memo,
                            expiration_date: this.inputs.expiration_date,
                            storage: this.inputs.storage,

                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                p.then((response) => {
                    // 성공처리
                    //console.log(response);
                    this.prod = response.prod;
                    this.openSuccessAlert();
                }).catch(() => {
                    // 오류인경우
                }).finally(() => {
                    this.isAjaxing = false;
                });
            },

        },
    }
</script>

<style lang="scss" scoped>

    h3 {
        margin: 1rem 0 0 1rem;
        font-size: 1.25rem;
        font-weight: bold;
    }

    .input-form {
        margin: 0 1rem;
        padding: 1rem;
        //background-color: #fff;
        //border: 1px solid #cfcfcf;
    }


    // 테이블
    .input-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        th, td {
            text-align: left;
            border: 1px solid #999;
            font-weight: normal;

            padding: 0.25rem;
            color: #000;
        }

        th {

            font-size: 1.25rem;
            background-color: #fefefe;
            width: 10rem;

            .material-icons {
                vertical-align: middle;
                font-size: 1.75rem;
                color: #aaa;
            }

            &.highlight .material-icons{
                color: #1e87f0 !important;
            }

        }
        td {
            text-align: center;
            font-size: 1.25rem;
            background-color: #fff;
            color: #000;
            //width: 25rem;

            &.highlight {
                //background-color: #ffffdd;
            }
        }

    }
</style>